import { Pipe, PipeTransform } from '@angular/core';

import { KpiLimit, KpiSetLimit } from 'app/kpi-notification-settings/kpi-notification-settings.model';

@Pipe({
    name: 'getRows',
    standalone: true,
})
export class GetRowsPipe implements PipeTransform {
    transform(index: number, kpiSetLimits: KpiSetLimit[], ungroupedLimits: KpiLimit[]): KpiLimit[] {
        return index < kpiSetLimits.length ? kpiSetLimits[index].limits : ungroupedLimits;
    }
}
